import React from 'react';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import { timeHMFormat } from 'utils/FormatDate';

const Chatting = ({left, message, date}) => {
    return (
        <>
            <Flex className={classNames('p-3', { 'd-block': !left })}>
                {/* {left && <Avatar size="l" className="me-2" src={user.avatarSrc} />} */}
                <div
                    className={classNames('flex-1', {
                    'd-flex justify-content-end': !left
                    })}
                >
                    <div
                        className={classNames('w-xxl-75', {
                            'w-100': !left
                        })}
                    >
                        <Flex
                            alignItems="center"
                            className={classNames('hover-actions-trigger', {
                            'flex-end-center': !left,
                            'align-items-center': left
                            })}
                        >
                            <>
                                <div
                                className={classNames('p-2 rounded-2 chat-message', {
                                    'bg-200': left,
                                    'bg-primary text-white light': !left
                                })}
                                >
                                {message && (
                                    <p
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{
                                        __html: message ? message : 'message'
                                    }}
                                    />
                                )}
                                {/* {message.attachment && (
                                    <FalconLightBox image={message.attachment}>
                                    <Image
                                        fluid
                                        rounded
                                        src={message.attachment}
                                        width={150}
                                        alt=""
                                    />
                                    </FalconLightBox>
                                )} */}
                                </div>
                            </>
                            {/* {!left && <ChatMessageOptions />}
                            {message.attachments ? (
                            <div className="chat-message chat-gallery">
                                {message.text && (
                                <p
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{
                                    __html: message.text ? message.text : message
                                    }}
                                />
                                )}
                                <FalconLightBoxGallery images={message.attachments}>
                                {setImgIndex => (
                                    <Row className="mx-n1">
                                    {message.attachments.map((img, index) => {
                                        return (
                                        <Col
                                            xs={6}
                                            md={4}
                                            className="px-1"
                                            style={{ minWidth: 50 }}
                                            key={index}
                                        >
                                            <Image
                                            fluid
                                            rounded
                                            className="mb-2 cursor-pointer"
                                            src={img}
                                            alt=""
                                            onClick={() => setImgIndex(index)}
                                            />
                                        </Col>
                                        );
                                    })}
                                    </Row>
                                )}
                                </FalconLightBoxGallery>
                            </div>
                            ) : (
                            <>
                                <div
                                className={classNames('p-2 rounded-2 chat-message', {
                                    'bg-200': left,
                                    'bg-primary text-white light': !left
                                })}
                                >
                                {(message || message.text) && (
                                    <p
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{
                                        __html: message.text ? message.text : message
                                    }}
                                    />
                                )}
                                {message.attachment && (
                                    <FalconLightBox image={message.attachment}>
                                    <Image
                                        fluid
                                        rounded
                                        src={message.attachment}
                                        width={150}
                                        alt=""
                                    />
                                    </FalconLightBox>
                                )}
                                </div>
                            </>
                            )} */}
                            {/* {left && <ChatMessageOptions />} */}
                        </Flex>
                        <div
                            className={classNames('text-400 fs--2', {
                            'text-end': !left
                            })}
                        >
                            {/* {left && isGroup && (
                            <span className="font-weight-semi-bold me-2">{name}</span>
                            )} */}
                            {timeHMFormat(date)}
                            {/* {!left && !!message && !!status && (
                            <FontAwesomeIcon
                                icon={classNames({
                                check: status === 'seen' || status === 'sent',
                                'check-double': status === 'delivered'
                                })}
                                className={classNames('ms-2', {
                                'text-success': status === 'seen'
                                })}
                            />
                            )} */}
                        </div>
                    </div>
                </div>
            </Flex>
        </>
    );
}

Chatting.propTypes = {}

export default Chatting;